import React from 'react'
import Layout from '../components/Layout/Layout'

const Privacy = () => {
    return (
        <Layout>
            <div className="row contactus ">
                <div className="col-md-6 ">
                    <img
                        src='https://img.freepik.com/premium-vector/privacy-policy-concept_118813-2611.jpg?size=626&ext=jpg&ga=GA1.2.158250536.1676270683&semt=ais'
                        alt="contactus"
                        style={{ width: "100%" }}
                    />
                </div>
                <div className="col-md-4">
                    <p>add privacy policy</p>
                    <p>add privacy policy</p>
                    <p>add privacy policy</p>
                    <p>add privacy policy</p>
                    <p>add privacy policy</p>
                    <p>add privacy policy</p>
                    <p>add privacy policy</p>
                </div>
            </div>
        </Layout>
    )
}

export default Privacy